<template>
<svg viewBox="0 0 35 35" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-WoDeWeiXuanZhong1`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M20.4755 9.39374H14.531H14.0254C12.1672 5.5795 10.6284 5.57743 9.39692 6.39516C7.00079 8.93799 5.23443 16.008 4.92883 18.5142C4.9288 27.4027 15.0131 28.0968 17.0811 28.0968C22.4497 28.0968 25.5202 26.9932 27.325 25.5134C30.8281 22.641 29.9447 17.1354 28.6348 12.7988C27.2594 8.24496 25.7762 6.17724 24.5976 6.17724C22.767 6.17724 22.3204 6.81032 21.2977 8.26001L21.2976 8.26004C21.0621 8.59389 20.796 8.97104 20.4755 9.39374ZM10.5475 15.6436C10.5475 15.1743 10.9279 14.7939 11.3971 14.7939H14.796C15.2652 14.7939 15.6456 15.1743 15.6456 15.6436C15.6456 16.1128 15.2652 16.4932 14.796 16.4932H11.3971C10.9279 16.4932 10.5475 16.1128 10.5475 15.6436ZM20.3385 14.7939C19.8693 14.7939 19.4889 15.1743 19.4889 15.6436C19.4889 16.1128 19.8693 16.4932 20.3385 16.4932H23.7374C24.2067 16.4932 24.587 16.1128 24.587 15.6436C24.587 15.1743 24.2067 14.7939 23.7374 14.7939H20.3385Z"/></svg>
</template>
<script>

export default {
  name: 'IconWoDeWeiXuanZhong1',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
